const convertTimestamp = timestamp => {
  const regex = /(.*)-/gm;
  const unixTime = String(new Date(Number(timestamp)));
  let m;

  while ((m = regex.exec(unixTime)) !== null) {
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }

    return m[1];
  }
};

export default convertTimestamp;



// WEBPACK FOOTER //
// ./src/util/convertTimestamp.js